﻿
export class CascadeData {

    constructor(public toField: string, public value: any) { }
}